import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Bar } from 'react-chartjs-2';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    MenuItem,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import "./overview.css";
import moment from 'moment/moment.js'
import DatePicker from 'react-date-picker';
// Create Document Component
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
})

export default class PDF extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            chartData: props.data,
            chart_option: props.option,
            raw_data: props.raw,
            agencies_output: props.agencies_output
        };
        console.log('saate',this.state);
    }
    
    componentDidUpdate(props) {
        this.state = {
            chartData: props.data,
            chart_option: props.option,
            raw_data: props.raw,
            agencies_output: props.agencies_output
        }
        console.log('saate update',this.state);
    }
    
    render() {
        return <div>
            <div style={{
                height: '60vh',
                maxHeight: '60vh'
            }}>
                <Bar data={this.state.chartData} options={this.state.chart_option}></Bar>
            </div>
            <div style={{
                width: "100%",
                overflow: "scroll"
            }}>
                <Table className="report_table">
                    <TableHead>
                        <TableRow >
                            <TableCell style={{
                                textAlign: "center",
                                backgroundColor: "black",
                                color: "white"
                            }}
                                colSpan={this.state.raw_data.length + 2}>Appointments</TableCell>

                        </TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                            {this.state.raw_data.map((row) => (
                                <TableCell>{row.name}</TableCell>
                            ))}
                            <TableCell
                                className="bold section_2"
                            >Total</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {this.state.agencies_output.map((row) => (
                            <TableRow>
                                { row.map((val) => (
                                    <TableCell className="bold">{val}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }} colSpan={this.state.raw_data.length + 1}>
                                Total
               </TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>{this.state.grand_total}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        </div>
    }
}
